import React, { useEffect, useRef, useCallback, useState} from 'react';
import {usePart} from './usePart.js';
import LandingPart2 from './LandingPart2.js';
import LandingPart3 from './LandingPart3.js';
import LandingPart4 from './LandingPart4.js';
import LandingPart5 from './LandingPart5.js';
import {connect} from 'react-redux';

const LandingAbout2 = ({setPart, children}) => { 
    let part2=useRef(undefined);
    let part3=useRef(undefined);
    let part4=useRef(undefined);
    let part5=useRef(undefined);
    usePart({parts: [undefined, undefined, part2, part3, part4, part5], setPart});
    return (
        <div className="landing-about">
          <div className="part-0">
            <div className="mission-text">
              <div>
                Tools for music-makers.
              </div>
              <div>
                Reinvented for the future of web.
              </div>
            </div>
            <div className="mission-prose">
              <div>
                A collaborative DAW.
              </div>
              <div>
                Open to anyone, anywhere.
              </div>
            </div>
          </div>
          <LandingPart2 part={part2} setPart={setPart}/>
          <LandingPart3 part={part3} setPart={setPart}/>
          <LandingPart4 part={part4} setPart={setPart}/>
          <LandingPart5 part={part5} setPart={setPart} contact={children}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingAbout2);
